import { callApi } from "../../utils/api";
import { showSuccessMessage, showErrorMessage } from '../../utils/messages'

/**
 * Acción para obtener temporizadores de un cliente
 */
export const fetchTimers = (clientId) => async (dispatch, getState) => {
  const state = getState();

  try {
    // Llamada a la API para obtener los temporizadores
    const response = await callApi(`/timer/getTimers/${clientId}`, {
      method: "GET",
      headers: {
        Authorization: state.app?.client?.token,
      },
    });
    if (response.status === 200) {
      dispatch({
        type: "FETCH_TIMERS_SUCCESS",
        payload: {
          activeTimers: response.body.activeTimers,
          expiredTimers: response.body.expiredTimers,
          clientHasntArrivedTimers: response.body.clientHasntArrivedTimers,
        },
      }); 
    } else {
      throw new Error(response.body?.error || "Error al obtener los temporizadores.");
    }
  } catch (error) {
    console.error("Error al obtener temporizadores:", error);
    dispatch({
      type: "FETCH_TIMERS_FAILURE",
      payload: error.message,
    });
  }
};


/**
 * Acción para crear un nuevo temporizador
 */
export const createTimer = (orderId, clientId, sysCompanyId, durationInSeconds) => async (dispatch, getState) => {
  const state = getState();
  const token = state.app.user?.token || state.app.waiter?.token || state.app.chef?.token || state?.app?.host?.token

  try {
    const response = await callApi(`/timer/createTimer`, {
      method: "POST",
      headers: {
        Authorization: token,
      },
      shouldSkipStatusError: true,
      body: JSON.stringify({
        orderId,
        clientId,
        sysCompanyId,
        durationInSeconds,
      }),
    });

  } catch (error) {
    console.error("Error al crear temporizador:", error);
    showErrorMessage("Error al crear temporizador ❌");
  }
};

/**
 * Acción para marcar temporizadores como leídos
 */
export const markTimersAsRead = (timerIds) => async (dispatch, getState) => {
  const state = getState();

  try {
    const response = await callApi(`/timer/updateExpired`, {
      method: "PATCH",
      headers: {
        Authorization: state.app?.client?.token,
      },
      body: JSON.stringify({ timerIds }),
    });
    console.log(response.status)
    if (response.status === 200) {
      dispatch({
        type: "MARK_TIMERS_AS_READ_SUCCESS",
        payload: timerIds,
      });
    } else {
      throw new Error(response.body?.error || "Error al marcar los temporizadores.");
    }
  } catch (error) {
    console.error("Error al marcar temporizadores:", error);
    showErrorMessage("Error al marcar temporizadores ❌");
  }
};

export const markTimersAsArrived = (timerIds) => async (dispatch, getState) => {
  const state = getState();

  try {
    const response = await callApi(`/timer/updateClientHasAlreadyArrived`, {
      method: "PATCH",
      headers: {
        Authorization: state.app?.client?.token,
      },
      body: JSON.stringify({ timerIds }),
    });
    console.log(response.status)
    if (response.status === 200) {
      dispatch({
        type: "MARK_TIMERS_AS_ARRIVED_SUCCESS",
        payload: timerIds,
      });
    } else {
      throw new Error(response.body?.error || "Error al marcar los temporizadores.");
    }
  } catch (error) {
    console.error("Error al marcar temporizadores:", error);
    showErrorMessage("Error al marcar temporizadores ❌");
  }
};